import React, { useState, useEffect } from 'react';
import { message, Spin } from 'antd';
import { ENDPOINTS, REQUEST_TYPES, MESSAGES } from './apiConfig';
import apiClient from './apiHelper';
import UserDetailView from './UserDetailView';

const UserProfile = () => {
    const [loading, setLoading] = useState(true);
    const [userDetails, setUserDetails] = useState(null);

    useEffect(() => {
        fetchUserDetails();
    }, []);

    const fetchUserDetails = async () => {
        try {
            const res = await apiClient(ENDPOINTS.USER.FETCH_USERS, {
                method: "POST",
                body: JSON.stringify({ request_type: REQUEST_TYPES.FETCH_USER_DETAILS }),
            });
            setUserDetails(res);
        } catch (error) {
            message.error(MESSAGES.ERROR.FETCH_USER_DETAILS);
        } finally {
            setLoading(false);
        }
    };

    const handleViewDocument = async (s3Path) => {
        if (!s3Path) {
            message.warning("No document path available.");
            return;
        }
        try {
            const response = await apiClient(ENDPOINTS.UPLOADS.FILE, {
                method: 'POST',
                body: JSON.stringify({
                    s3_key: s3Path,
                    request_type: REQUEST_TYPES.DOWNLOAD_FILE
                })
            });
            if (response && response.download_url) {
                window.open(response.download_url, '_blank', 'noopener,noreferrer');
            }
        } catch (error) {
            message.error("Failed to load document.");
        }
    };

    return (
        <div className="max-w-5xl m-auto p-4">
            {loading ? (
                <div className="flex justify-center py-20"><Spin size="large" /></div>
            ) : (
                <UserDetailView
                    data={userDetails}
                    handleViewDocument={handleViewDocument}
                />
            )}
        </div>
    );
};

export default UserProfile;